import { Outlet } from 'react-router-dom'

const AuthenticationLayout = () => {
  return (
    <div className="w-full h-screen flex justify-center items-center p-8">
      <Outlet />
    </div>
  )
}

export default AuthenticationLayout
